// LandingSearch.jsx
import React, { useEffect, useState } from "react";
import PageList from "../../reusable_components/pageList";
import headerLogo from "../../assets/images/landing/header-logo.svg";
import gradLeaf from "../../assets/images/icons/icon-grad-leaf.svg";
import lockedQR from "../../assets/images/locked-QR.png";
import userDp from "../../assets/images/user-dp.png";
import trustedShield from "../../assets/images/icons/icon-trusted-shield.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ErrorToast from "../../reusable_components/ErrorToast";
import { GET_PRODUCT_DETAILS_ID } from "../../services/Api";
import axios from "axios";
import {
  formatDate,
  formatHour,
  formatMinute,
  formatSecond,
  formatTime,
} from "../../services/utils";

import { toast, ToastContainer } from "react-toastify";

export default function LandingSearch() {
  const [productDetails, setProductDetails] = useState({});
  const [data, setData] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const stateValue = new URLSearchParams(location.search).get("state");

  // Header active state from URL param
  const [activeSection, setActiveSection] = useState(stateValue || "home");

  useEffect(() => {
    // keep activeSection in sync if URL param changes
    if (stateValue) setActiveSection(stateValue);
  }, [stateValue]);

  const getDetails = async (id) => {
    try {
      let res = await axios.get(`${GET_PRODUCT_DETAILS_ID}/${id}`);
      let data = res?.data;
      if (data?.msg?.includes("Invalid")) {
        toast(<ErrorToast content={data?.msg} />, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
      if (data) {
        setData(data);
      }
    } catch (error) {
      console.log({ error });
      toast(<ErrorToast content={"Oops, Error Occurred"} />, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    getDetails(id);
  }, [id]);

  useEffect(() => {
    if (data) {
      setProductDetails(data);
    }
  }, [data]);

  const handleToast = () => {
    toast(<ErrorToast content={"Please login for more Info..!"} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3000,
    });
  };

  return (
    <div className="landing paye-layout">
      <PageList />
      <div className="pb-0 content-layout">
        <header className="position-static headerSec">
          <nav className="headerSec__inner">
            <Link className="headerSec__logo" to="">
              <img src={headerLogo} alt="logo" />
            </Link>
          </nav>
        </header>

        {/* Rest of LandingSearch content unchanged */}
        <section className="tracker-screen-s2 cs4 mb-4 mb-lg-0">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="border-white-2 tracking-status">
                <div className="tracking-status__search">
                  <div
                    onClick={handleToast}
                    className="main-shadow block-wavy-dark"
                  >
                    <span className="gradientText fw600 fz16">
                      Asset Details
                    </span>
                  </div>

                  <div className="search-images">
                    <div className="search-images__locked">
                      <img className="main-shadow" src={lockedQR} alt="" />
                    </div>
                  </div>

                  <ul className="list-inline m-0 pairs">
                    <li>
                      <div className="fz20 pairs__text">
                        <div className="label">Asset ID</div>
                        <div className="fw600 value">{productDetails?.id}</div>
                      </div>
                    </li>
                    <li>
                      <div className="fz20 pairs__text">
                        <div className="label">Asset Name</div>

                        <div className="fw600 value">
                          {productDetails?.product?.name}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="fz20 pairs__text">
                        <div className="label">Asset Brand</div>

                        <div className="fw600 value">
                          {productDetails?.product?.brand}
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="fz20 pairs__text">
                        <div className="label">Added:</div>
                        <div className="fw600 value">
                          {formatDate(productDetails?.created_at)} |
                          {formatHour(productDetails?.created_at)} hrs :{" "}
                          {formatMinute(productDetails?.created_at)}mins :{" "}
                          {formatSecond(productDetails?.created_at)}secs
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div
                    onClick={handleToast}
                    className="main-shadow block-wavy-dark"
                  >
                    <span className="gradientText fw600 fz16">
                      Current Owner
                    </span>
                  </div>

                  <div className="spacer"></div>

                  {productDetails?.all_owner?.map((owner, index) => (
                    <div className="tracker-info-wrapper mb-5" key={index}>
                      <div className="tracker-info">
                        <div className="tracker-user-card-wrapper">
                          <div className="user-card-dot"></div>

                          <div className="tracker-user-card position-relative">
                            <span className="tagBefore">
                              <span className="fw600 fz14 gradientText--radial">
                                P{index + 1}
                              </span>
                            </span>

                            <div className="user-tracking-pic d-flex">
                              <div className="page-header__user-info round_pf_pic">
                                <div className="rounded-circle user-img">
                                  <span className="rounded-circle">
                                    <img src={userDp} alt="User" />
                                  </span>
                                </div>
                              </div>

                              <div className="user-tracking-info">
                                <h3 className="m-0 fw600 fz16">
                                  {owner?.name}
                                </h3>

                                <p className="d-flex align-items-center trusted-user">
                                  <img src={trustedShield} alt="" />
                                  <span className="fw500 fz12">
                                    Trusted Owner
                                  </span>
                                </p>
                              </div>
                            </div>

                            <div className="d-flex justify-content-end tracking-date-tag">
                              <span className="date_btn">
                                {/* {formatDate(productDetails?.created_at)} */}
                                 {formatDate(owner?.created_at)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <span className="tracker-info-wrapper-dot"></span>
                    </div>
                  ))}
                </div>
                <div className="text-start border-0 login-search-block">
                  <button
                    onClick={() => navigate("/login")}
                    role="button"
                    className="main-shadow block-wavy-dark"
                  >
                    <div className="title">
                      <img src={gradLeaf} alt="" />
                      <h2 className="fz24 mb-0 fw600 gradientText--radial">
                        <span>
                          Login for detailed view or track your product
                        </span>
                      </h2>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ToastContainer />
      </div>
    </div>
  );
}
